export type SpecialRequirementConfig = {
  label: string;
  value: string;
};

export type SpecialRequirementFormEntry = {
  label?: string;
  value?: boolean | string;
  additional_information?: string;
};

export type SyncedSpecialRequirement = {
  label: string;
  value: string;
  additional_information: string;
};

export function syncSpecialRequirementsFromConfig(
  specialRequirementValues: SpecialRequirementConfig[],
  existing: Record<string, SpecialRequirementFormEntry> = {},
): Record<string, SyncedSpecialRequirement> {
  const specialRequirements: Record<string, SyncedSpecialRequirement> = {};

  specialRequirementValues.forEach((item) => {
    const existingEntry = existing[item.value];
    const hadDifferentLabel = Boolean(existingEntry?.label && existingEntry.label !== item.label);

    if (hadDifferentLabel) {
      specialRequirements[item.value] = {
        label: item.label,
        value: "false",
        additional_information: "",
      };
      return;
    }

    const existingValue = existingEntry?.value;
    const isYes = existingValue === true || existingValue === "true";
    const isNo = existingValue === false || existingValue === "false";

    specialRequirements[item.value] = {
      label: item.label,
      value: isYes ? "true" : isNo ? "false" : "false",
      additional_information: isYes ? existingEntry?.additional_information ?? "" : "",
    };
  });

  return specialRequirements;
}
